import { formatKey } from "../../_helper";

const EffectedWalletComponent = ({
  title,
  data = {},
  columns = 2,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
}) => {
  const gridColumnsClass = `lg:tw-grid-cols-${columns}`;
  const isNegative = data?.transaction_type === "(-)";

  return (
    <section className={className}>
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div
        className={`tw-grid ${gridColumnsClass} tw-grid-cols-1 tw-gap-2 tw-text-gray-700`}
      >
        {Object.entries(data)
          .filter(([key]) => key !== "client_id")
          .map(([key, value]) => (
            <div key={key}>
              <p>
                <strong className="tw-text-primary">{formatKey(key)}:</strong>{" "}
                {key === "transaction_type" ? (
                  <span
                    className={
                      isNegative ? "tw-text-red-500" : "tw-text-green-500"
                    }
                  >
                    {value}
                  </span>
                ) : (
                  value
                )}
              </p>
            </div>
          ))}
      </div>
    </section>
  );
};

export default EffectedWalletComponent;
